import React from 'react';
import Logo from './Logo';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100">
      <div className="text-center space-y-6">
        {/* Logo with pulse animation */}
        <div className="flex justify-center mb-4">
          <div className="animate-pulse">
            <Logo className="h-12" showText={true} variant="dark" />
          </div>
        </div>
        
        {/* Spinner */}
        <div className="relative">
          <div className="w-12 h-12 mx-auto rounded-full border-4 border-neutral-200 border-t-primary-500 animate-spin"></div>
        </div>
        
        {/* Loading text */}
        <p className="text-sm text-neutral-500 font-medium">Loading your workspace...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
